export const nl = {
    global: {
        Submit: 'Bevestig',
        Export: 'Exporteer',
        New: 'Nieuw',
        Reset: 'Reset',
        Filter: 'Filter',
        Yes: 'Ja',
        No: 'Nee',
        Update: 'Bewerken',
        Delete: 'Verwijderen'
    },
    swal: {
        general: {
            Title: 'Bent u zeker?',
            CancelButtonText: 'Annuleer'
        },
        logout: {
            Title: 'Weet je het zeker?',
            Text: 'U keert terug naar de inlogpagina.',
            ConfirmButtonText: 'Ja, log me uit!',
            CancelButtonText: 'Annuleer',
            SuccessTitle: "Opgeslaan!",
            SuccessMsg: "Formulier is succesvol opgeslaan."
        },
        approve: {
            Title: 'Bent u zeker?',
            Text: 'De metingen zullen zichtbaar zijn voor de klant.',
            ConfirmButtonText: 'Ja, keur nu goed.',
            CancelButtonText: 'Annuleer'
        },
        delete: {
            Text: 'Dit item zal verwijderd worden.',
            ConfirmButtonText: 'Ja, verwijder nu.',
            SuccessTitle: "Verwijderd!",
        }
    },
    sidebar: {
        NewMeasurement: 'Nieuwe meting',
        Overview: 'Overzicht',
        Monitoring: 'Controle',
        Components: 'Onderdelen',
        Customers: 'Klanten',
        Users: 'Gebruikers',
        Brands: 'Merken',
        Logout: 'Afmelden'
    },
    router: {
        OverviewMeasurements: 'Overzicht metingen',
        NewMeasurement: 'Nieuwe meting',
        UpdateMeasurement: 'Bewerk meting',
        MonitoringMeasurements: 'Controle metingen',
        OverviewComponents: 'Overzicht onderdelen',
        NewComponent: 'Nieuw onderdeel',
        UpdateComponent: 'Bewerk onderdeel',
        ViewComponent: 'Details onderdeel',
        OverviewComponenttypes: 'Overzicht types',
        NewComponenttype: 'Nieuw type',
        UpdateComponenttype: 'Bewerk type',
        OverviewCustomer: 'Overzicht klanten',
        NewCustomer: 'Nieuwe klant',
        UpdateCustomer: 'Bewerk klant',
        OverviewUsers: 'Overzicht gebruikers',
        CreateUser: 'Nieuwe gebruiker',
        UpdateUser: 'Bewerk gebruiker',
        OverviewBrands: 'Overzicht merken',
        NewBrand: 'Nieuw merk',
        UpdateBrand: 'Bewerk merk',
    },
    table: {
        NoData: 'Geen gegevens beschikbaar.',
        NextLabel: 'Volgende',
        PrevLabel: 'Vorige',
        RowsPerPageLabel: 'Rijen per pagina',
        OfLabel: 'van',
        PageLabel: 'pagina', // for 'pages' mode
        AllLabel: 'Alle',
    },
    landingpage: {
        SignIn: 'Aanmelden',
        banner1: {
            Title: 'Herhaaldelijk onderhoud nodig voor uw industriële procescomponenten?',
            Button: 'Contacteer ons'
        },
        sectionIcons: {
            column1: {
                Title: 'Traceerbaarheid',
                Content: 'We voeren elk onderdeel in onze interne tool zodat alle gegevens worden geanalyseerd voor het best mogelijke onderhoud.',
            },
            column2: {
                Title: 'Unieke Identificatie',
                Content: 'Elk onderdeel dat we ontvangen voor onderhoud krijgt een uniek nummer.',
            },
            column3: {
                Title: 'Meerstapsbehandeling',
                Content: 'Wij zijn gespecialiseerd in het reinigen van diverse componenten, zoals kogelkranen of vlamdovers.',
            }
        },
        section1: {
            Title: 'Vervolgprogrammaondersteuning voor herhaalde schoonmaakbeurten',
            Content: 'Elk onderdeel dat we ontvangen voor onderhoud krijgt een uniek nummer en wordt ingevoerd in onze interne tool. Deze tool slaat alle technische gegevens van elk onderdeel op en analyseert ze. Zo weten we wanneer de beste onderhoudsinterval voor het onderdeel is.',
            Content2: 'Ook heeft u toegang tot dit systeem om de gegevens van uw componenten te bekijken!'
        },
        section2: {
            Title: 'Voldoet aan uw wettelijke vereisten!',
            Content: 'Het onderhoud van sommige procescomponenten is verplicht. Wij zorgen voor het noodzakelijke onderhoud en leveren digitale reinigingscertificaten.',
            Content2: 'Wij regelen het transport van en naar uw bedrijf!'
        },
        section3: {
            Title: 'Meerstapsbehandeling',
            Content: 'Wij zijn gespecialiseerd in het onderhoud van componenten. Deze interne tool is zeer geschikt voor de volgende componenten: kogelkranen, roerwerk verwijderen, drukvaccuumkleppen en vlamdovers.'
        },
        sectionExamples: {
            Title: 'Enkele voorbeelden van onderdelen die we reinigen....',
            Example1: 'Kogelkranen',
            Example2: 'Vlammenvangers',
            Example3: 'Drukventielen'
        },
        banner2: {
            Title: 'Klaar om te beginnen? Neem dan nu contact met ons op!',
            Button: 'Contacteer ons'
        },
    },
    measurement: {
        Measurement: 'Meting',
        Customer: 'Klant',
        Component: 'Onderdeel',
        Pollution_rate: 'Vervuiling',
        Date: 'Datum',
        Note: 'Opmerkingen',
        Clean: 'Proper',
        Dirty: 'Vuil',
        BtnApprove: 'Goedkeuren',
        Wear_rate: 'Slijtage',
        Rates: 'Beoordeling',
        Type: 'Type',
        Approved: 'Goedgekeurd',
        None: 'Geen',
        Much: 'Veel',
        Packet: 'Process component',
        Back_pressure_rate: 'Tegendruk',
        Weight_rate: 'Gewicht',
        Filter_measurements: 'Extra metingen',
        Leakage_rate: 'Leksnelheid',
        Brand: 'Merk',
        in_date: 'IN',
        control_date: 'Controle',
        Actions: 'Acties'
    },
    component: {
        Types: 'Types',
        Number: 'Onderdeel',
        PacketNumber: 'Process component',
        IntervalControl: 'Reinigingscontrole',
        ComponentTypeId: 'Type',
        CustomerId: 'Klant',
        CreateSuccess: 'Onderdeel succesvol opgeslaan!',
        Customer: 'Klant',
        Type: 'Type',
        max_pollution_rate: 'Max. vervuiling',
        max_wear_rate: 'Max. slijtage',
        Brand: 'Merk',
        Note: 'Opmerking',
        min_wear_rate: 'Min. wear',
        min_weight_rate: 'Min. weight',
        max_weight_rate: 'Max. weight',
        min_back_pressure_rate: 'Min. backpressure',
        max_back_pressure_rate: 'Max. backpressure',
        max_leakage_rate: 'Max. leakage',
        min_leakage_rate: 'Min. leakage',
        Max: 'Max',
        Min: 'Min',
        weight: 'Gewicht (gr)',
        backpressure: 'Onderdruk (mm/h2o)',
        leakage: 'Lek',
        pollution: 'Vervuiling',
        wear: 'Slijtage',
        Status: 'Status',
        Actions: 'Acties'
    },
    componenttype: {
        Name: 'Naam',
        IntervalControl: 'Datum volgende inspectie',
        CreateSuccess: 'Type succesvol opgeslaan!',
        General: 'Algemeen',
        MinMax: 'Min/Max waarden',
    },
    customer: {
        Name: 'Naam',
        CreateSuccess: 'Klant succesvol opgeslaan!'
    },
    brand: {
        Name: 'Naam'
    }
}
